module.exports = __webpack_public_path__ + "assets/icon-instruments.0c97a5fa.svg";